var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _circle, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 32,
    viewBox: "0 0 125 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 21.8866H49.3981V9.07214H47V21.8866Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.964 20.2756C61.6461 21.5753 59.9435 22.1794 58.0943 22.1794C53.3346 22.1794 51.3209 18.9026 51.3028 15.571C51.2846 12.221 53.4628 8.81567 58.0943 8.81567C59.8336 8.81567 61.4814 9.47469 62.7995 10.7745L61.1882 12.3306C60.3463 11.5071 59.2115 11.1225 58.0943 11.1225C55.0007 11.1225 53.6643 13.4291 53.6829 15.571C53.7009 17.6946 54.9276 19.9098 58.0943 19.9098C59.2115 19.9098 60.4743 19.4521 61.3166 18.61L62.964 20.2756Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5545 15.9001H70.1792C73.2728 15.9001 73.2547 11.3599 70.1792 11.3599H66.5545V15.9001ZM70.1792 18.1154H66.5544V21.8864H64.1379V9.07195C66.1518 9.07195 68.1655 9.05371 70.1792 9.05371C76.44 9.05371 76.4582 18.1154 70.1792 18.1154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4238 12.166C83.9848 11.4335 82.7762 10.738 81.3852 10.738C79.591 10.738 78.7306 11.4884 78.7306 12.4406C78.7306 13.5572 80.0485 13.8686 81.5866 14.0517C84.2593 14.3812 86.7487 15.0765 86.7487 18.1336C86.7487 20.9896 84.2223 22.2162 81.3665 22.2162C78.7489 22.2162 76.735 21.4109 75.7834 19.0676L77.7967 18.024C78.3643 19.4334 79.8472 20.0561 81.4033 20.0561C82.9227 20.0561 84.3507 19.5251 84.3507 18.1336C84.3507 16.9257 83.0875 16.4312 81.3852 16.2481C78.7669 15.9372 76.3506 15.2415 76.3506 12.3673C76.3506 9.73094 78.9502 8.65119 81.3116 8.63263C83.3071 8.63263 85.3758 9.20027 86.3463 11.177L84.4238 12.166Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5635 12.8432L98.5405 19.6347L100.609 12.8432H103.081L99.9315 21.9235H97.3321L96.3986 19.2508L95.5933 16.23L94.7874 19.2508L93.8539 21.9235H91.2544L88.0872 12.8432H90.5773L92.6455 19.6347L94.6048 12.8432H96.5635Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.861 20.088C106.452 20.088 105.305 18.9409 105.305 17.531C105.305 16.1214 106.452 14.9743 107.861 14.9743C109.271 14.9743 110.418 16.1214 110.418 17.531C110.418 18.9409 109.271 20.088 107.861 20.088ZM110.441 13.5087C109.669 13.0124 108.779 12.7506 107.861 12.7506C105.225 12.7506 103.081 14.8954 103.081 17.5311C103.081 20.1672 105.225 22.3118 107.861 22.3118C108.779 22.3118 109.669 22.05 110.441 21.5537V22.1273H112.642V12.9166H110.441V13.5087Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 12,
    width: 11,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.133 12.7412H124.113V25.7503H114.133V12.7412Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.332 20.0784C117.922 20.0784 116.775 18.9315 116.775 17.5216C116.775 16.1118 117.922 14.9649 119.332 14.9649C120.742 14.9649 121.889 16.1118 121.889 17.5216C121.889 18.9315 120.742 20.0784 119.332 20.0784ZM119.332 12.7412C118.244 12.7412 117.183 13.1176 116.334 13.8033V12.9621H114.133V25.7503H116.334V21.2402C117.183 21.926 118.244 22.3024 119.332 22.3024C121.968 22.3024 124.113 20.1576 124.113 17.5217C124.113 14.886 121.968 12.7412 119.332 12.7412Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9707 7.20001C17.4803 7.20001 15.6815 9.19209 15.2017 10.5987C14.3601 12.7633 14.7154 14.426 15.0285 15.8923L15.0512 15.9991C15.3419 17.3628 15.6163 18.6508 15.2234 20.2673C15.1869 20.4886 15.1221 20.7063 15.0307 20.9143C14.5812 21.9452 13.5617 22.6109 12.4338 22.6109C10.8728 22.6109 9.60277 21.3485 9.60277 19.7964C9.60277 18.2437 10.8728 16.9805 12.4338 16.9805C12.8542 16.9805 13.2582 17.0706 13.6355 17.2478L13.9643 17.4025L13.5546 14.9127L13.4253 14.8867C13.101 14.8218 12.7673 14.7892 12.4338 14.7892C9.65803 14.7892 7.3999 17.0353 7.3999 19.7964C7.3999 22.5576 9.65803 24.8036 12.4338 24.8036C14.7381 24.8036 16.7435 23.2539 17.3075 21.0474C17.8778 19.3192 17.6112 17.7424 17.2333 16.0072L17.1911 15.8141C16.8203 14.1169 16.5273 12.7763 17.4106 11.0062C17.8756 10.026 18.8803 9.39237 19.9707 9.39237C21.531 9.39237 22.8007 10.6548 22.8007 12.2068C22.8007 13.7588 21.531 15.0217 19.9707 15.0217C19.5838 15.0217 19.2081 14.9453 18.8528 14.794L18.5334 14.6584L18.9368 17.1101L19.0695 17.1343C19.3643 17.1873 19.6676 17.2145 19.9707 17.2145C22.7458 17.2145 25.0035 14.9679 25.0035 12.2068C25.0035 9.44603 22.7458 7.20001 19.9707 7.20001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.264463,
    y1: 15.1351,
    x2: 29.2813,
    y2: 14.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5569DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8572FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.7b8c12091e650c40c5e9f561c57473ba.svg";
export { ForwardRef as ReactComponent };